import { AxiosError } from "axios";
import { Dispatch, SetStateAction, createContext, useContext } from "react";

import { RequestAuthorization } from "../types/requestAuthorization.ts";
import { REQUEST_STATUS } from "./requestStatus.ts";

export type APIContext = {
  emit: (obj: APIResponseEvent<unknown, unknown>) => void;
  subscribe: (cb: APIResponseSubscriber) => () => void;
  // Pending request for authorization
  setRequestAuthorization: Dispatch<
    SetStateAction<RequestAuthorization | null>
  >;
  /**
   * User has authorized with less secure method.
   * They now should be prompted to install mobile key app.
   */
  showMobileKeyPrompt: boolean;
  setShowMobileKeyPrompt: Dispatch<SetStateAction<boolean>>;
};

export const APIContext = createContext<APIContext | null>(null);

export const useAPIContext = () => {
  const context = useContext(APIContext);
  if (!context) {
    throw new Error("useAPIContext must be used within a APIProvider");
  }

  return context;
};

export type APIResponseSubscriber = (
  obj: APIResponseEvent<unknown, unknown>,
) => void;

export type APIResponseEventFinished<TRequest, TResponse> = {
  type: typeof REQUEST_STATUS.FINISHED;
  url: string;
  code: number;
  data: TResponse;
  request: TRequest;
};

export type APIResponseEventError = {
  type: typeof REQUEST_STATUS.FAILED;
  url: string;
  err: AxiosError | Error;
};

export type APIResponseEvent<TRequest, TResponse> =
  | APIResponseEventFinished<TRequest, TResponse>
  | APIResponseEventError;
